import { useParams } from "react-router-dom";
import CheckoutSuccess from "@src/components/checkout/success";
import PageLayout from "@src/components/shared/page-layout";

interface CheckoutSuccessPageParams {
  transactionHash: string;
}

const CheckoutSuccessPage = (): JSX.Element => {
  const { transactionHash } = useParams<CheckoutSuccessPageParams>();

  return (
    <PageLayout>
      <CheckoutSuccess transactionHash={transactionHash} />
    </PageLayout>
  );
};

export default CheckoutSuccessPage;
